// Central brand + contact constants so the phone/WhatsApp stay consistent everywhere.
export const BRAND = "Arıcıoğlu Nakliyat";

export const PHONE_DISPLAY = "0312 378 20 10";
export const PHONE_TEL = "+903123782010";
export const WHATSAPP_URL =
  "https://wa.me/905055979406?text=" +
  encodeURIComponent(
    "Merhaba, Dikmen evden eve nakliyat ve asansörlü taşıma için bilgi almak istiyorum."
  );

export const ADDRESS = "İncili Sokak 48/B Etlik Mah. Keçiören / ANKARA";
export const MAPS_EMBED =
  "https://maps.google.com/maps?q=" +
  encodeURIComponent(ADDRESS) +
  "&z=15&output=embed";
export const MAPS_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=" +
  encodeURIComponent(ADDRESS);

/** public/1.jpeg … public/18.jpeg */
export const IMG = {
  1: "/1.jpeg",
  2: "/2.jpeg",
  3: "/3.jpeg",
  4: "/4.jpeg",
  5: "/5.jpeg",
  6: "/6.jpeg",
  7: "/7.jpeg",
  8: "/8.jpeg",
  9: "/9.jpeg",
  10: "/10.jpeg",
  11: "/11.jpeg",
  12: "/12.jpeg",
  13: "/13.jpeg",
  14: "/14.jpeg",
  15: "/15.jpeg",
  16: "/16.jpeg",
  17: "/17.jpeg",
  18: "/18.jpeg",
};
